<template>
  <section class="customization-tab">
    <div class="customization-tab__fonts">
      <h1 class="h1">Guestbook font</h1>
      <div class="field-wrapper">
        <GlobalInputDropdown
          label="Font family"
          v-model="customFont"
          :options="guestbookFonts"
        />
        <p class="preview-text" 
          :style="{'font-family': customFont }"
        >
          This is the preview of the font.
        </p>
      </div>
      <button-global
        type="positive"
        size="small"
        text="SAVE"
        margin="0"
        @eventPassed="() => updateGuestbookFont()"
      ></button-global>
    </div>

    <div class="customization-tab__languages">
      <div class="column-wrapper">
        <h1 class="h1">Add extra languages for your events</h1>
        <div class="field-wrapper">
          <template v-if="currentLanguages.length > 0">
            <div 
              v-for="(language, index) in currentLanguages"
              :key="index"
            >
            <div class="input-group">
              <GlobalInputDropdown
                :label="index == 0 ? 'Default Language' : `${language.foreignName} Language`"
                :value="language.countryCode"
                @input="onLanguageChange($event, index)"
                :options="languagesArray"
              />
            </div>
            </div>
          </template>
        </div>
      </div>
      <button-global
        class="box-button"
        type="positive"
        text="ADD"
        @eventPassed="isAddLangModalVisible = true"
      ></button-global>

      <LanguageTabAddButton
        v-if="isAddLangModalVisible"
        @close="isAddLangModalVisible = false"
        @addedLanguage="fetchExisitingLanguages()"
      />
    </div>

  </section>
</template>
<script>
import { db } from "@/firebase";
import languages from "@/languages.json";
import newLanguageTypesFormatMixin from "@/mixins/newLanguageTypesFormatMixin";
import LanguageTabAddButton from "@/components/SettingsPage/LanguageTabAddButton";
import GlobalInputDropdown from "@/components/GlobalComponents/GlobalInputDropdown";
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";

export default {
  components: {
    LanguageTabAddButton,
    GlobalInputDropdown,
    ButtonGlobal,
  },
  mixins: [newLanguageTypesFormatMixin],
  data() {
    return {
      isAddLangModalVisible: false,
      languagesArray: languages,
      currentLanguageTypes: [],
      currentLanguages: [],
      customFont: 'Poppins',
      guestbookFonts: [
        {
          value: 'Poppins',
          text: 'Poppins'
        },
        {
          value: 'Brandon Text Black',
          text: 'Brandon Text Black'
        }
      ]
    };
  },
  created() {
    this.fetchExisitingLanguages();
    db.ref(`customers/${this.$customerId}/fonts`)
      .once('value')
      .then( snapshot => {
        if(snapshot.exists()) {
          let fonts = snapshot.val();
          this.customFont = fonts.customFonts ? fonts.customFontCss : 'Poppins';
        }
      })
  },
  methods: {
    async fetchExisitingLanguages() {
      this.currentLanguageTypes = (await db.ref(`customers/${this.$customerId}/languageTypes`).once("value")).val();
      const languageSnapshots = await Promise.all(this.currentLanguageTypes.map( countryCode => db.ref(`languages/${countryCode}`).once("value")));
      
      const currentLanguages = [];

      languageSnapshots.map(snapshot => {
        const {
          countryCode,
          foreignName,
          nativeName
        } = snapshot.val();
        
        currentLanguages.push({
          countryCode,
          foreignName,
          nativeName
        })

      });

      this.currentLanguages = currentLanguages;
    },
    async onLanguageChange(selectedLanguage, index) {
      await db.ref(`customers/${this.$customerId}/languageTypes`).update({
        [index]: selectedLanguage
      });

      const selectedLanguageObject = (await db.ref(`languages/${selectedLanguage}`).once("value")).val()
      
      if (!selectedLanguageObject) {
        await this._updateLanguagesInFirebase(selectedLanguage);
      }

      this.$toastEvents.push({
        type: "positive",
        title: "Awesome!",
        content: "Language has been changed",
        id: +new Date(),
      });

      this.fetchExisitingLanguages();

    },
    updateGuestbookFont() {
      db.ref(`customers/${this.$customerId}/fonts`).set(
        this.customFont === 'Poppins' ? {
          'customFontCss': 'Poppins',
          'customFonts': false,
        } : {
          'customFontCss': this.customFont,
          'customFonts': true
        }
      );
      this.$toastEvents.push({
        type: "positive",
        title: "Success",
        content: "Guestbook font settings have been updated",
        id: +new Date(),
      });
    },
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.column-wrapper {
  display: flex;
  flex-direction: column;
}

.field-wrapper {
  width: 45%;
}

</style>
